import { useState } from 'react'
import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'

const ackcImg = require('../../assets/images/active_kids.png')

const StyledACKC = styled.div`
  border-bottom: 1px solid ${theme.colors.border};
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(10)};
`
const StyledImg = styled.img`
  width: 12%;
`
const StyledHeader = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: ${rem(10)};
  transtion: transform 0.5s;

  > p {
    margin: 0;

    span {
      color: ${theme.colors.teal};
      text-decoration: underline;
    }
  }

  img {
    margin-top: -${rem(56)};
  }

  ${props =>
    props.isOpen &&
    css`
      span {
        transform: rotate(180);
      }
    `}
`
const StyledContent = styled.div`
  display: none;
  flex-direction: column;
  > p {
    margin-top: 0;
  }

  ${props =>
    props.isOpen &&
    css`
      display: flex;
    `}
`

export const ACKC = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <StyledACKC>
      <StyledHeader onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        <p>
          NSW Government Active & Creative Kids Voucher <br />
          <span>More info ({isOpen ? 'Hide' : 'Show'})</span>
        </p>
        <StyledImg src={ackcImg?.default} alt="Active Kids Logo" />
      </StyledHeader>
      <StyledContent isOpen={isOpen}>
        <p>
          If you wish to claim the NSW Government Active & Creative Kids Voucher, please enter the Voucher Code in the
          box below.
        </p>
        <p>
          A voucher can only be redeemed against a single registered provider in any one transaction. If you are
          purchasing a product from the registered provider that is less than $50.00 you cannot redeem the balance of
          the voucher.
        </p>
        <p>
          Enter your voucher number and select Validate. The redeemable value of the voucher will be deducted in the
          summary below.
        </p>
      </StyledContent>
    </StyledACKC>
  )
}
